import React, { Component } from 'react'
import { FiChevronUp, FiMapPin, FiDownload } from "react-icons/fi";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import Header from "../component/header/Header";

class NearbyPlaces extends Component {
    render() {
        return (
            <>
                <PageHelmet pageTitle='ลัดเลาะรอบเมืองสิงห์ท่า' />

                {/* Start Header Area  */}
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />
                {/* End Header Area  */}
                

                {/* Start Page Wrapper  */}
                <main className="page-wrapper">

                    {/* Hero Section */}
                    <div className="hero-section" style={{
                        background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        minHeight: '50vh',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <div className="container">
                            <div className="row justify-content-center text-center">
                                <div className="col-lg-8">
                                    <h1 className="hero-title" style={{
                                        color: 'white',
                                        fontSize: '3.5rem',
                                        fontWeight: 'bold',
                                        marginBottom: '1.5rem',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                    }}>
                                        ลัดเลาะรอบเมืองสิงห์ท่า
                                    </h1>
                                    <p className="hero-subtitle" style={{
                                        color: 'white',
                                        fontSize: '1.3rem',
                                        opacity: 0.9,
                                        marginBottom: '2rem',
                                        textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                        lineHeight: '1.6'
                                    }}>
                                        สำรวจสถานที่สำคัญและจุดท่องเที่ยวรอบๆ พิพิธภัณฑ์สิงห์ท่า<br />
                                        พร้อมแผนที่และข้อมูลการเดินทาง
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map Section */}
                    <div className="map-section ptb--80" style={{ backgroundColor: 'white' }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <div className="map-container" style={{
                                        backgroundColor: 'white',
                                        borderRadius: '20px',
                                        padding: '2rem',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        minHeight: '600px'
                                    }}>
                                        <div className="map-header" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '2rem',
                                            paddingBottom: '1rem',
                                            borderBottom: '2px solid #f0f0f0'
                                        }}>
                                            <h3 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                แผนที่พิพิธภัณฑ์สิงห์ท่า
                                            </h3>
                                        </div>
                                        
                                        <div className="map-viewer" style={{
                                            width: '100%',
                                            textAlign: 'center'
                                        }}>
                                            <img
                                                src="/assets/images/singha/MAP_A4_02.png"
                                                alt="แผนที่พิพิธภัณฑ์สิงห์ท่า"
                                                style={{
                                                    maxWidth: '100%',
                                                    height: 'auto',
                                                    borderRadius: '15px',
                                                    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tourist Attractions Section */}
                    <div className="attractions-section ptb--80" style={{ backgroundColor: '#f8f9fa' }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center mb-5">
                                        <h2 className="title" style={{
                                            fontSize: '2.5rem',
                                            fontWeight: 'bold',
                                            color: '#242424',
                                            marginBottom: '1rem'
                                        }}>
                                            สถานที่ท่องเที่ยวใกล้เคียง
                                        </h2>
                                        <p style={{
                                            color: '#666',
                                            fontSize: '1.5rem',
                                            maxWidth: '800px',
                                            margin: '0 auto'
                                        }}>
                                           สำรวจสถานที่ท่องเที่ยวที่น่าสนใจรอบๆ พิพิธภัณฑ์สิงห์ท่า พร้อมลิงก์แผนที่และข้อมูลการเดินทาง
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Living Old Town Section */}
                            <div className="row mb-5">
                                <div className="col-lg-12">
                                    <div className="attraction-category" style={{
                                        backgroundColor: 'white',
                                        borderRadius: '20px',
                                        padding: '2rem',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                        marginBottom: '2rem'
                                    }}>
                                        <h3 style={{
                                            fontSize: '2rem',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '1.5rem',
                                            textAlign: 'center',
                                            borderBottom: '3px solid #F45354',
                                            paddingBottom: '1rem'
                                        }}>
                                            🏛️ ท่องเที่ยวเมืองเก่าที่มีชีวิต
                                        </h3>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="attraction-list">
                                                    {[
                                                        { name: 'ประตูเมืองบ้านสิงห์ท่า', link: 'https://maps.app.goo.gl/SDAHm9CbWos8yoyF6' },
                                                        { name: 'มูลนิธิรวมสามัคคียโสธร', link: 'https://maps.app.goo.gl/x4S9B9GtjpM1sQGZ7' },
                                                        { name: 'มนูญบาร์เบอร์', link: 'https://maps.app.goo.gl/oP4HPP1n7TnwJbGL9?g_st=al' },
                                                        { name: 'บ้านดิน', link: 'https://maps.app.goo.gl/Sr4Rvaxdi9v5FgiP8?g_st=al' },
                                                        { name: 'ร้านสุรเวช', link: 'https://maps.app.goo.gl/b2QExcRbepiH58iz7' }
                                                    ].map((item, index) => (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0.75rem 1rem',
                                                            marginBottom: '0.5rem',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '10px',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#e9ecef';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                        }}>
                                                            <span style={{ fontWeight: '500', color: '#333' }}>{index + 1}. {item.name}</span>
                                                            <a 
                                                                href={item.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '0.5rem 1rem',
                                                                    backgroundColor: '#28a745',
                                                                    color: 'white',
                                                                    textDecoration: 'none',
                                                                    borderRadius: '25px',
                                                                    fontSize: '0.9rem',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#218838';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#28a745';
                                                                }}
                                                            >
                                                                <FiMapPin style={{ marginRight: '0.5rem' }} />
                                                                แผนที่
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="attraction-list">
                                                    {[
                                                        { name: 'ร้านสมกอสถาน', link: 'https://maps.app.goo.gl/gvA6QA14bARXUpKf7' },
                                                        { name: 'ร้านแม่ขวัญ', link: 'https://maps.app.goo.gl/pnXaD3wi98Fo5Bef9?g_st=al' },
                                                        { name: 'ร้านสมประสงค์', link: 'https://maps.app.goo.gl/MganbjBi6dwHjjgA8?g_st=al' },
                                                        { name: 'ยโสธรภาพยนตร์ (สิงห์ท่าเธียเตอร์)', link: 'https://maps.app.goo.gl/Qi2uPQ2NwZXqGvfk9?g_st=al' },
                                                        { name: 'ร้านยะโสธรพาณิชย์', link: 'https://maps.app.goo.gl/3QKLgJKk7wRDg3yg8' }
                                                    ].map((item, index) => (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0.75rem 1rem',
                                                            marginBottom: '0.5rem',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '10px',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#e9ecef';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                        }}>
                                                            <span style={{ fontWeight: '500', color: '#333' }}>{index + 6}. {item.name}</span>
                                                            <a 
                                                                href={item.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '0.5rem 1rem',
                                                                    backgroundColor: '#28a745',
                                                                    color: 'white',
                                                                    textDecoration: 'none',
                                                                    borderRadius: '25px',
                                                                    fontSize: '0.9rem',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#218838';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#28a745';
                                                                }}
                                                            >
                                                                <FiMapPin style={{ marginRight: '0.5rem' }} />
                                                                แผนที่
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Spiritual Tourism Section */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="attraction-category" style={{
                                        backgroundColor: 'white',
                                        borderRadius: '20px',
                                        padding: '2rem',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                    }}>
                                        <h3 style={{
                                            fontSize: '2rem',
                                            fontWeight: 'bold',
                                            color: '#6f42c1',
                                            marginBottom: '1.5rem',
                                            textAlign: 'center',
                                            borderBottom: '3px solid #6f42c1',
                                            paddingBottom: '1rem'
                                        }}>
                                            🙏 ท่องเที่ยวสายมู
                                        </h3>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="attraction-list">
                                                    {[
                                                        { name: 'ศาลเจ้าปู่ยโสธร', link: 'https://maps.app.goo.gl/oZKrEK6gEjT615JL7' },
                                                        { name: 'วัดมหาธาตุ', link: 'https://maps.app.goo.gl/JWMSkW8BctenJ53H7' },
                                                        { name: 'ศาลเจ้าแม่สองนาง (ริมถนนแจ้งสนิท)', link: 'https://maps.app.goo.gl/4UFEgeon4uJY5CLq5' },
                                                        { name: 'อนุสาวรีย์พระสุนทรราชวงศา', link: 'https://maps.app.goo.gl/vop9tmqqRLv7iqNK7' },
                                                        { name: 'ศาลเจ้าพ่อหอชุม', link: 'https://maps.app.goo.gl/AykTGaZDDxh2eXtV9' },
                                                        { name: 'หอมเหศักดิ์บ้านสิงห์ท่า', link: 'https://maps.app.goo.gl/yEk83xdQezNQi7PC6?g_st=al' }
                                                    ].map((item, index) => (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0.75rem 1rem',
                                                            marginBottom: '0.5rem',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '10px',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#e9ecef';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                        }}>
                                                            <span style={{ fontWeight: '500', color: '#333' }}>{index + 1}. {item.name}</span>
                                                            <a 
                                                                href={item.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '0.5rem 1rem',
                                                                    backgroundColor: '#6f42c1',
                                                                    color: 'white',
                                                                    textDecoration: 'none',
                                                                    borderRadius: '25px',
                                                                    fontSize: '0.9rem',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#5a32a3';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#6f42c1';
                                                                }}
                                                            >
                                                                <FiMapPin style={{ marginRight: '0.5rem' }} />
                                                                แผนที่
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="attraction-list">
                                                    {[
                                                        { name: 'ศาลเจ้าพ่อหลักเมือง', link: 'https://maps.app.goo.gl/Zy1GFHp8umgBktrB8' },
                                                        { name: 'วัดสิงห์ท่า', link: 'https://maps.app.goo.gl/DnjeDNWFgoQYanKo6' },
                                                        { name: 'หอเจ้าแม่สองนาง', link: 'https://maps.app.goo.gl/Ev822BuPUgJN6GyDA' },
                                                        { name: 'พระธาตุเอียง', link: 'https://maps.app.goo.gl/Vc5p8z246mGTcKwT6' },
                                                        { name: 'วัดศรีธรรมาราม', link: 'https://maps.app.goo.gl/NnfdScmyCEFpe2eD6' },
                                                        { name: 'วัดศรีไตรภูมิ', link: 'https://maps.app.goo.gl/SufUDYnfinmbDDTq7' }
                                                    ].map((item, index) => (
                                                        <div key={index} style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '0.75rem 1rem',
                                                            marginBottom: '0.5rem',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '10px',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#e9ecef';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                        }}>
                                                            <span style={{ fontWeight: '500', color: '#333' }}>{index + 7}. {item.name}</span>
                                                            <a 
                                                                href={item.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '0.5rem 1rem',
                                                                    backgroundColor: '#6f42c1',
                                                                    color: 'white',
                                                                    textDecoration: 'none',
                                                                    borderRadius: '25px',
                                                                    fontSize: '0.9rem',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#5a32a3';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#6f42c1';
                                                                }}
                                                            >
                                                                <FiMapPin style={{ marginRight: '0.5rem' }} />
                                                                แผนที่
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
                {/* End Page Wrapper  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
            </>
        )
    }
}

export default NearbyPlaces;
